import api from '@/services/Api';
import { AxiosResponse } from 'axios';
import { ActionContext, Module } from 'vuex';
import { ReiseState, RootState } from '@/store/types';
import Reiseziel from '@/types/Reiseziel';
import Reiseart from '@/types/Reiseart';

type Context = ActionContext<ReiseState, RootState>;

export const reise: Module<ReiseState, RootState> = {
    namespaced: true,
    state: {
        reiseziele: [],
        reisearten: [],
        loaders: {
            reiseziele: false,
            reisearten: false,
        },
    },
    actions: {
        loadReiseziele({ commit }: Context): void {
            commit('setLoadersReiseziele', true);

            api.post('verwaltung/reiseziele/load')
                .then((response) => commit('setReiseziele', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersReiseziele', false));
        },
        loadReisearten({ commit }: Context): void {
            commit('setLoadersReisearten', true);

            api.post('verwaltung/reisearten/load')
                .then((response: AxiosResponse) => commit('setReisearten', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersReisearten', false));
        },
    },
    mutations: {
        setReiseziele(state: ReiseState, reiseziele: Reiseziel[]): void {
            state.reiseziele = reiseziele;
        },
        setReisearten(state: ReiseState, reisearten: Reiseart[]): void {
            state.reisearten = reisearten;
        },
        setLoadersReiseziele(state: ReiseState, loading: boolean): void {
            state.loaders.reiseziele = loading;
        },
        setLoadersReisearten(state: ReiseState, loading: boolean): void {
            state.loaders.reisearten = loading;
        },
    },
};
